export default (v) => {
    if (!v) {
        return '';
    }
    let initials = v.replace(/[^a-zA-Z- ]/g, "").match(/\b\w/g);
    return initials.join('').toUpperCase();
}



// WEBPACK FOOTER //
// ./resources/assets/js/filters/iniciales.js